/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const WifiNotificationIconOutline = createIcon({
  displayName: 'WifiNotificationIconOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M11.999,19.25a.375.375,0,1,0,.376.375.37216.37216,0,0,0-.376-.375"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M7.579,15.821a6.27591,6.27591,0,0,1,8.841,0"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M12,9.18524A10.946,10.946,0,0,0,4.591,12"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M12,4A15.72447,15.72447,0,0,0,1.594,7.804"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <circle
        cx="18"
        cy="7"
        r="2"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path d="M0,0H24V24H0Z" fill="none" />
    </>
  ),
})

const WifiNotification: FC<CustomIconProps> = (props) => {
  switch (props.variant) {
    default:
      return <CustomIcon as={WifiNotificationIconOutline} {...props} />
  }
}

export default memo(WifiNotification)
